import React from 'react';

interface PageProps {
  id?: string;
  className?: string;
  center?: boolean;
  children?: React.ReactNode;
}

export const Page: React.FC<PageProps> = (props) => {
  return (
    <div className={'' + (props.className ? ' ' + props.className : '')} id={props.id}>
      {props.children}
    </div>
  );
};
